<template>
  <span>{{ value ? $n(value / 100, 'currency', currency) : '-' }}</span>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String]
      },
      currency: {
        type: String,
        default: 'EUR'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/formatters/Price.vue